import { SongsService } from './../../api/services/songs-service';
import { Component, OnInit,EventEmitter,Output } from '@angular/core';
import { Router,NavigationExtras,ActivatedRoute } from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ScrollService} from '../../api/';

@Component({
  selector: 'app-song-detail',
  templateUrl: './song-detail.component.html',
  styleUrls: ['./song-detail.component.css']
})
export class SongDetailComponent implements OnInit {
  public slug: any;
  public song: any;
  private readMore = false;
  private searchfromPopup = false;
  private lyricSlice: number = 400;
  private type: string = '';
  @Output() refreshList2: EventEmitter<any> = new EventEmitter();
  private innerwidthCheck = false;
  private innerwidthCheck2 = false;
  private firefox = false;
  @BlockUI() blockUI: NgBlockUI;
  creditsArray: any;
  localStorageSongs = [];

  constructor(private scrollService: ScrollService,public dialogRef: MdDialogRef<SongDetailComponent>,public dialog: MdDialog,private route: ActivatedRoute, private router: Router, private songService: SongsService) {
    this.dialogRef.afterClosed().subscribe(() => {
      this.blockUI.stop();
    });
  }

  ngOnInit() {
    if(this.route.snapshot.data['type']) {
      this.type = this.route.snapshot.data['type'];
    }
    if(screen.width <= 1024) {
      this.lyricSlice = 215;
    } else if(screen.width <= 1400) {
      this.lyricSlice = 400;
    } else if(screen.width <= 3070) {
      this.lyricSlice = 550;
    } else {
      this.lyricSlice = 700;
    }
    this.innerwidthCheck = false;
    this.innerwidthCheck2 = false;
    if(window.innerWidth > 1800) {
      this.innerwidthCheck2 = true;
    } else {
      this.innerwidthCheck2 = false;
    }
    if(window.innerWidth > 1800) {
      this.innerwidthCheck = true;
      this.lyricSlice = 750;
    }
    if(window.innerWidth > 2600) {
      this.innerwidthCheck = null;
      this.lyricSlice = 775;
    }

    // check if the song object exists
    if(this.song && typeof this.song !== 'undefined') {
      if(this.song.lyrics != null) {
        this.song.songLyrics = this.song.lyrics;
        this.song.songLyrics2 = this.song.songLyrics.slice(0, this.lyricSlice);
      }
      this.removeSlash();
      this.removeDuplicatCredits();
      this.blockUI.stop();
    }

    // check if the slug is passed from the parent component instead of song object
    if(this.slug && typeof this.slug !== 'undefined') {
      var localSong = [];
      // get songs from local storage before sending an API call
      this.localStorageSongs = JSON.parse(localStorage.getItem("songDetail"));
      // check if the song exists in local storage
      if(this.localStorageSongs) {
        localSong = this.localStorageSongs.filter(x => x.slug == this.slug);
      } else {
        this.localStorageSongs = [];
      }
      if(localSong.length > 0) {
        this.song = localSong[0];
        console.log(this.song);
        // to update the data on frontend when ever we update the meta data from backend side
        this.songService.getSongDetailBySlug(this.slug).subscribe(res => {
          this.song = res;
          if(res.lyrics != null) {
            this.song.songLyrics = res.lyrics;
            this.song.songLyrics2 = res.songLyrics.slice(0, this.lyricSlice);
          }
          this.removeSlash();
          this.removeDuplicatCredits();
          var index = this.localStorageSongs.findIndex(i => i.slug === res.slug);
          if(index != -1) {
            this.localStorageSongs[index] = this.song;
          }
          // storing the song in local storage to avoid extra API calls
          localStorage.setItem("songDetail" , JSON.stringify(this.localStorageSongs));
        });
      } else {
        if(typeof this.slug === 'string') {
          this.songService.getSongDetailBySlug(this.slug).subscribe(res => {
            this.song = res;
            if(res.lyrics != null) {
              this.song.songLyrics = res.lyrics;
              this.song.songLyrics2 = res.songLyrics.slice(0, this.lyricSlice);
            }
            this.removeSlash();
            this.removeDuplicatCredits();
            this.localStorageSongs.push(this.song);
            // storing the song in local storage to avoid extra API calls
            localStorage.setItem("songDetail" , JSON.stringify(this.localStorageSongs));
            this.blockUI.stop();
          });
        }
      }
    }
    this.scrollService.enableScrollIfDisabled();
  }

  navigateToArtist() {
    this.dialogRef.close();
    this.router.navigate(['/artist/' + this.song.artist.slug]);
  }

  RedirectToSongsSearch(type, name, islocation, iswriter, ispublisher, islabel){
    if(islabel){
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'namee': name,
          'islabel': islabel
        },
      };
      this.router.navigate(['/songssearchoncredits'], navigationExtras);
    } else if(iswriter) {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'namee': name,
          'iswriter': iswriter
        },
      };
      this.router.navigate(['/songssearchoncredits'], navigationExtras);
    } else if(ispublisher) {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'namee': name,
          'ispublisher': ispublisher
        },
      };
      this.router.navigate(['/songssearchoncredits'], navigationExtras);

    } else {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'namee': name,
          'type': type,
          'islocation': islocation
        },
      };
      this.router.navigate(['/songssearchoncredits'], navigationExtras);
    }
    if(this.dialogRef) {
      this.dialogRef.close();
    }
      if(this.type  == "CS") {
      this.refreshList2.emit();
    }
  }

  toggleReadMore() {
    this.readMore = !this.readMore;
  }

  // redirect to artist page based on the location
  redirectToArtistSearch(location) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'q': location,
        'type': 'location'
      },
    };
    this.router.navigate(['/artists'], navigationExtras);
  }

  removeSlash() {
    if (this.song) {
      if (typeof this.song.credits === "object" && this.song.credits != null) {
        for (var i = 0; i < this.song.credits.length; i++) {
          this.song.credits[i].credit_type = this.song.credits[i].credit_type.replace("_", " ");
          this.song.credits[i].credit_type = this.song.credits[i].credit_type.charAt(0).toUpperCase() + this.song.credits[i].credit_type.slice(1);
        }
      }
    }
  }

  removeDuplicatCredits() {
    for (let e = 0; e < 4; e++) {
      if(this.song.writers) {
        this.song.writers.forEach((item, index) => {
            // Compare the writer names and remove the duplicate record
          if (index !== this.song.writers.findIndex(i => i.writer === item.writer)) {
            this.song.writers.splice(index, 1);
          }
        });
      }
    }

    for (let f = 0; f < 4; f++) {
      this.creditsArray = new Array<any>();
      if(this.song.credits) {
        this.song.credits.forEach((item, index) => {
          if (index !== this.song.credits.findIndex(i => i.credit_type === item.credit_type)) {
            this.creditsArray.push(this.song.credits[index]);
          }
        });
      }
    }

    for (let j = 0; j < this.creditsArray.length; j++) {
      for (let k = 0; k < this.song.credits.length; k++) {
        if (this.song.credits[k].credit_type == this.creditsArray[j].credit_type) {
          if (!(this.song.credits[k].name.includes(this.creditsArray[j].name))) {
            if (!this.song.credits[k].values) {
              this.song.credits[k]["values"] = [];
            }
            if (!(this.song.credits[k].values.includes(this.song.credits[k].name))) {
              this.song.credits[k].values.push(this.song.credits[k].name);
            }
            if (!(this.song.credits[k].values.includes(this.creditsArray[j].name))) {
              this.song.credits[k].values.push(this.creditsArray[j].name);
            }
          }
        }
      }
    }

    for (let f = 0; f < 4; f++) {
      this.creditsArray = new Array<any>();
      if(this.song.credits) {
        this.song.credits.forEach((item, index) => {
          if (index !== this.song.credits.findIndex(i => i.credit_type === item.credit_type)) {
            this.creditsArray.push(this.song.credits[index]);
            this.song.credits.splice(index, 1);
          }
        });
      }
    }

    if(this.song.credits) {
      for(let k = 0; k < this.song.credits.length; k++) {
        if(!this.song.credits[k].values) {
          this.song.credits[k]["values"] = [];
        }
        if(!(this.song.credits[k].values.includes(this.song.credits[k].name))) {
          let locationPartt = this.song.credits[k].name.split(",");
          for (let p = 0; p < locationPartt.length; p++) {
            locationPartt[p].replace(",", "");
            this.song.credits[k].values.push(locationPartt[p]);
          }
        }
        if(this.song.credits[k].location && this.song.credits[k].location != null) {
          this.song.credits[k]["locations"] = [];
          let locationParts = this.song.credits[k].location.split(",");
          for (let m = 0; m < locationParts.length; m++) {
            if (!(locationParts[m].includes("."))) {
              this.song.credits[k].locations.push(locationParts[m]);
            } else {
              let locationParts2 = locationParts[m].split(".");
              for (let n = 0; n < locationParts2.length; n++) {
                this.song.credits[k].locations.push(locationParts2[n]);
              }
            }
          }
        }
      }
    }

    //publisher array making
    if(!this.song.publishers) {
      this.song["publisherss"] = [];
      if(this.song.publisher) {
        var locationParttt = this.song.publisher.split(",");
        for (let p = 0; p < locationParttt.length; p++) {
          locationParttt[p].replace(",", "");
          this.song.publisherss.push(locationParttt[p]);
        }
      }
    } else {
      this.song["publisherss"] = [];
      for (let m = 0; m < this.song.publishers.length; m++) {
        if (this.song.publishers[m].publisher) {
          this.song.publisherss.push(this.song.publishers[m].publisher);
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/songs/song-detail/song-detail.component.ts